const cmsStore = {
  uiHidden: localStorage.getItem('uiHidden') === 'true' ? true : false as boolean,

  init() {
    setTimeout(() => { this.hideUI() }, 100);
    console.log('cmsStore initialized');

    // listen to § keypress event
    document.addEventListener('keypress', (event) => {
      if (event.key === '§' || event.key === '`') {
        this.uiHidden = !this.uiHidden;
        localStorage.setItem('uiHidden', this.uiHidden.toString());
        this.hideUI();
      }
    });
  },

  hideUI() {
    const elementsToHide = document.querySelectorAll('.admin-toolbar-control-bar, .admin-toolbar, .gin--navigation-top-bar') as NodeListOf<HTMLElement>;

    if (elementsToHide.length > 0) {
      elementsToHide.forEach(element => {
        element.style.display = this.uiHidden ? 'none' : 'block';
      });
    }

    const canvas = document.querySelector('[data-off-canvas-main-canvas]') as HTMLElement;
    if (canvas) {
      canvas.classList[this.uiHidden ? 'remove' : 'add']('dialog-off-canvas-main-canvas');
    }
  }
};

export default cmsStore;
